<template>
  <button aria-expanded={isActive} v-bind:class="getClasses()" @click="showMenu()">
      <!-- Burger Menu -->
      <span></span>
  </button>
</template>

<script>
export default {
    name: 'ButtonMenu',
    data: () => ({
        isActive: false,
    }),
    methods: {
        /**
         * Inserts css proper classes for the button Menu.
         * If Menu is Active, then inserts the "active" class.
         */
        getClasses: function () {
            return {
                'button-menu': true,
                'button-menu--active': this.isActive,
            }
        },
        /**
         * Shows the Menu Component
         * and sets the "state" of the current button (isActive)
         */
        showMenu: function () {
            // Toggle isActive
            this.isActive = !this.isActive

            // TODO Show the menu!
        }
    }
}
</script>

<style lang="scss">
    @import './buttonmenu.scss';
</style>